export enum PaperAccessButtonType {
  FULL_TEXT = "full-text",
  UPLOAD_PDF = "upload-pdf",
  OPEN_ACCESS_PDF = "open-access-pdf",
  MANAGE_PDF = "manage-pdf",
}

export type PaperAccessButtonProps = {
  uploaded_paper_id?: string;
  isUploading?: boolean;
  onDelete?: () => void;
};
